import { Contratacion } from './Contratacion';
import { FichaXConratacionXHi } from './FichaXContratacionXHi';
import { CodSubTipoFichaFUR } from '../general/variables';

export class FichaXContratacion {
    nfichaxcontratId: number;
    nfichaxcontratIdficha: number;
    cfichaxcontratCodtipo: string = CodSubTipoFichaFUR;
    nfichaxcontratIdcontrat: number;
    contratacion: Contratacion;
    listaFichaPorContratacionPorHechoIrregular: FichaXConratacionXHi[];
    // listaFurPorObraPubPorHechoIrr: FurXObraPublicaXHi[];
}
